import { map } from 'lodash';
import type { IObjectiveHealth } from './ObjectiveHealth.interface';
import ObjectiveApplicant from './ObjectiveApplicant';

export default class ObjectiveHealth implements IObjectiveHealth {
  applicants: Array<ObjectiveApplicant>;

  static build = (data: IObjectiveHealth) => new ObjectiveHealth(data);
  static blank = () => new ObjectiveHealth();

  /**
   * Constructor
   * @param {IObjectiveHealth} data
   */
  constructor(data?: IObjectiveHealth) {
    this.applicants = map(data?.applicants, (obj) => new ObjectiveApplicant(obj));
  }
}
